var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsDateString, IsObject, IsString, IsUUID } from 'class-validator';
import { OfficeLocationStub } from '../../offices/index.js';
export class PreventionCourseVoucherFullSizeDto {
    id;
    createdAt;
    updatedAt;
    code;
    officeLocationId;
    officeLocation;
    preventionCourseId;
    preventionCourse;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], PreventionCourseVoucherFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], PreventionCourseVoucherFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], PreventionCourseVoucherFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], PreventionCourseVoucherFullSizeDto.prototype, "code", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], PreventionCourseVoucherFullSizeDto.prototype, "officeLocationId", void 0);
__decorate([
    IsObject(),
    Type(() => OfficeLocationStub),
    Expose(),
    __metadata("design:type", Function)
], PreventionCourseVoucherFullSizeDto.prototype, "officeLocation", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], PreventionCourseVoucherFullSizeDto.prototype, "preventionCourseId", void 0);
__decorate([
    IsObject(),
    Expose(),
    __metadata("design:type", Function)
], PreventionCourseVoucherFullSizeDto.prototype, "preventionCourse", void 0);
//# sourceMappingURL=prevention-course-voucher.full-size.dto.js.map